<template>
    <div id="planning_kecamatan" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Biodata Pegawai</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button @click="check_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                        </span>
                        <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        <span class="input-group-btn">
                            <button @click="getJabatanCetak()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Cetak Data" data-toggle="modal" data-target="#m_cetak_data"><i class="material-icons">print</i></button>
                        </span>
                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->

        <br>
            <div class="row">
<!-- <div id="people"></div> -->
                

                <div class="col-md-6">
   
                    <span class="huruf_input">Unit Kerja</span>
                    <autocomplete
                        :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                        :customHeaders="{authorization: 'kikensbatara '+token }"
                        anchor="unit_kerja"
                        :initValue="''"
                        :placeholder="unit_kerja_full"
                        :classes="{ input: 'form-control'}"
                        label="writer"
                        :onShouldRenderChild="renderChild"
                        :on-select="getAuto">
                    </autocomplete>
                    
                    

                </div>
                <div class="col-md-6">
                    
                </div>

            </div>
        <br>

            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-success">
                        <th style="width: 5%" class="text-center">No.</th>
                        <th style="width: 20%" class="text-center">Nama</th>
                        <th style="width: 20%" class="text-center">NIP</th>
                        <th style="width: 40%" class="text-center">Jabatan</th>
                        <th style="width: 15%" class="text-center"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- track-by="data.createdtime" -->
                        <tr v-if="cek_load_data">
                            <td colspan="5" class="text-center">
                                <img src="images/loading.gif" width="10%">
                            </td>
                        </tr>
                        <!-- track-by="data.createdtime" -->
                        <template v-if="!cek_load_data">
                            <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{check_gelar_depan(data.gelar_depan)}}{{data.nama}}{{check_gelar_belakang(data.gelar_belakang)}}</td>
                                <td class="text-center">{{data.nip}}</td>
                                <td>{{data.nm_jabatan}}</td>
                                <td class="text-center" >
                                    <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Lihat Detil Profil Pegawai" data-toggle="modal" data-target="#m_lihat_data">
                                        <i class="material-icons" >search</i>
                                    </button>
                                        &nbsp;
                                    <button @click="selectData(data)" class="btn bg-orange btn-xs waves-effect" title="Edit Data Pegawai" data-toggle="modal" data-target="#m_edit_data">
                                        <i class="material-icons" >create</i>
                                    </button>
                                        &nbsp;
                                    <button @click="removeData(data.id, data.file)" class="btn bg-red btn-xs waves-effect" title="Tambah Riwayat Pendidikan" data-toggle="modal" data-target="#m_list_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                                </td>
                            </tr>
                        </template>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                        <i class="material-icons">skip_previous</i>
                    </button>
                    &nbsp;
                    <span style="font-size: 85%; color: #a5a5a5">
                        <b>{{page_first}} - {{page_last}}</b>
                    </span>
                    &nbsp;
                    <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                        <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>
            <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                <div class="modal-body">
                                    <div v-if="cek_unit">

                                        <span class="huruf_input">Upload Foto ASN</span>
                                        <input @change="onFileSelected" type="file" class="form-control"  accept="image/*"> <br>

                                        <span class="huruf_input">Nama ASN</span>
                                        <input v-model="form.nama" type="text" id="nilai" class="form-control" ><br>

                                        <span class="huruf_input">NIP</span>
                                        <input v-model="form.nip" type="text" id="nilai" class="form-control" > <br>

                                        <div class="row">
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Gelar Depan</span>
                                                    <input v-model="form.gelar_depan" type="text" id="nilai" class="form-control" >
                                            </div>
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Gelar Belakang</span>
                                                    <input v-model="form.gelar_belakang" type="text" id="nilai" class="form-control" >
                                            </div>
                                        </div><br>

                                        <span class="huruf_input">Tanggal Lahir</span>
                                        <input v-model="form.ttl" type="date" id="nilai" class="form-control date" ><br>

                                        <span class="huruf_input">Tempat Lahir</span>
                                        <input v-model="form.tempat_lahir" type="text" id="nilai" class="form-control date" ><br>

                                        <span class="huruf_input">Jenis Kelamin</span>
                                        <select v-model="form.jenis_kelamin" class="form-control">
                                            <option>Laki-laki</option>
                                            <option>Perempuan</option>
                                        </select>
                                        <br>
                        
                                        <span class="huruf_input">Status Keluarga</span>
                                        <select v-model="form.status_keluarga" class="form-control">
                                            <option>Nikah</option>
                                            <option>Belum Nikah</option>
                                            <option>Duda</option>
                                            <option>Janda</option>
                                        </select> <br>

                                        <span class="huruf_input">Agama</span>
                                        <select v-model="form.agama" class="form-control">
                                            <option>Islam</option>
                                            <option>Katolik</option>
                                            <option>Protestan</option>
                                            <option>Hindu</option>
                                            <option>Buddha</option>
                                            <option>Kong Hu Cu</option>
                                        </select> <br>

                                        <span class="huruf_input">Pendidikan Akhir</span>
                                        <select v-model="form.pendidikan_ahir" class="form-control">
                                            <option>S3</option>
                                            <option>S2</option>
                                            <option>S1</option>
                                            <option>D4</option>
                                            <option>D3</option>
                                            <option>D2</option>
                                            <option>D1</option>
                                            <option>SLTA</option>
                                            <option>SLTP</option>
                                            <option>SD</option>
                                        </select> <br>

                                        <div class="row">
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Nama Sekolah</span>
                                                    <input v-model="form.sekolah" type="text" id="nilai" class="form-control" >
                                            </div>
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Thn Lulus</span>
                                                    <input v-model="form.thn_lulus" type="text" id="nilai" class="form-control" >
                                            </div>
                                        </div><br>

                                        <span class="huruf_input">TMT CPNS</span>
                                        <input v-model="form.tmt_cpns" type="date" id="nilai" class="form-control" data-date-format="DD MMMM YYYY"><br>

                                        <div class="row">
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Golongan</span>
                                                    <select v-model="form.gol" class="form-control">
                                                        <option selected="" disabled="">Golongan</option>
                                                        <option>IV/d</option>
                                                        <option>IV/c</option>
                                                        <option>IV/b</option>
                                                        <option>IV/a</option>
                                                        <option>III/d</option>
                                                        <option>III/c</option>
                                                        <option>III/b</option>
                                                        <option>III/a</option>
                                                        <option>II/c</option>
                                                        <option>II/b</option>
                                                        <option>II/a</option>
                                                        <option>I/c</option>
                                                    </select> <br>
                                            </div>

                                            <div class="col-md-6">
                                                    <span class="huruf_input">TMT Golongan</span>
                                                    <input v-model="form.tmt_golongan" type="date" id="nilai" class="form-control" >
                                            </div>
                                        </div><br>

                                        <div class="row">
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Nama Jabatan</span>
                                                    <select v-model="form.jabatan" class="form-control" id="esselon">
                                                        <option>-- Pilih Atasan Langsung Jabatan</option>
                                                        <option v-for="data in list_jabatan" :value="data._id" :key="data._id">[{{data.kode_jabatan}}] {{data.jabatan}}</option>
                                                    </select><br>
                                            </div>
                                            <div class="col-md-6">
                                                    <span class="huruf_input">TMT Jabatan</span>
                                                    <input v-model="form.tmt_jabatan" type="date" id="nilai" class="form-control" >
                                            </div>
                                        </div><br>

                                        <div class="row">
                                            <div class="col-md-6">
                                                    <span class="huruf_input">No Karpeg</span>
                                                    <input v-model="form.no_karpeg" type="text" id="nilai" class="form-control" >
                                            </div>
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Kepemilikan Taspen</span>
                                                    <select v-model="form.taspen" class="form-control" id="esselon">
                                                        <option>Ada</option>
                                                        <option>Tidak Ada</option>
                                                    </select><br>
                                            </div>
                                        </div><br>

                                        <span class="huruf_input">Nomor NPWP</span>
                                        <input v-model="form.NPWP" type="text" id="nilai" class="form-control" ><br>

                                        <span class="huruf_input">Alamat Rumah</span>
                                        <input v-model="form.alamat" type="text" id="nilai" class="form-control" ><br>

                                        <div class="row">
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Kota </span>
                                                    <input v-model="form.kota_asal" type="text" id="nilai" class="form-control" >
                                            </div>
                                            <div class="col-md-6">
                                                    <span class="huruf_input">Kode Pos</span>
                                                    <input v-model="form.kode_pos" type="text" id="nilai" class="form-control" >
                                            </div>
                                        </div><br>

                                        <span class="huruf_input">Nomor Kontak</span>
                                        <input v-model="form.kontak" type="text" id="nilai" class="form-control" ><br>


                                    
                                    

                                    </div>
                                    <div  v-if="!cek_unit">
                                        <div class="alert alert-info text-center"><strong>SILAHKAN PILIH UNIT KERJA TERLEBIH DAHULU!</strong></div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="addData()" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>

                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">

                                    <span class="huruf_input">Upload Foto ASN</span>
                                    <input @change="onFileSelected" type="file" class="form-control"  accept="image/*"> <br>

                                    <div v-if="cek_edit">
                                        <span class="huruf_input">Unit Kerja</span>
                                        <autocomplete
                                            :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                            :customHeaders="{authorization: 'kikensbatara '+token }"
                                            anchor="unit_kerja"
                                            :initValue="nm_unit_kerja"
                                            :placeholder="unit_kerja_full"
                                            :classes="{ input: 'form-control'}"
                                            label="writer"
                                            :onShouldRenderChild="renderChild"
                                            :on-select="getAuto1">
                                        </autocomplete> <br>

                                    </div>

                                    <span class="huruf_input">Nama ASN</span>
                                    <input v-model="form.nama" type="text" id="nilai" class="form-control" ><br>

                                    <span class="huruf_input">NIP</span>
                                    <input v-model="form.nip" type="text" id="nilai" class="form-control" > <br>

                                    <div class="row">
                                        <div class="col-md-6">
                                                <span class="huruf_input">Gelar Depan</span>
                                                <input v-model="form.gelar_depan" type="text" id="nilai" class="form-control" >
                                        </div>
                                        <div class="col-md-6">
                                                <span class="huruf_input">Gelar Belakang</span>
                                                <input v-model="form.gelar_belakang" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div><br>

                                    <span class="huruf_input">Tanggal Lahir</span>
                                    <input v-model="form.ttl" type="text" id="nilai" class="form-control" ><br>

                                    <span class="huruf_input">Tempat Lahir</span>
                                    <input v-model="form.tempat_lahir" type="text" id="nilai" class="form-control" ><br>

                                    <span class="huruf_input">Jenis Kelamin</span>
                                    <select v-model="form.jenis_kelamin" class="form-control">
                                        <option>Laki-laki</option>
                                        <option>Perempuan</option>
                                    </select>
                                    <br>
                    
                                    <span class="huruf_input">Status Keluarga</span>
                                    <select v-model="form.status_keluarga" class="form-control">
                                        <option>Nikah</option>
                                        <option>Belum Nikah</option>
                                        <option>Duda</option>
                                        <option>Janda</option>
                                    </select> <br>

                                    <span class="huruf_input">Agama</span>
                                    <select v-model="form.agama" class="form-control">
                                        <option>Islam</option>
                                        <option>Katolik</option>
                                        <option>Protestan</option>
                                        <option>Hindu</option>
                                        <option>Buddha</option>
                                        <option>Kong Hu Cu</option>
                                    </select> <br>

                                    <span class="huruf_input">Pendidikan Akhir</span>
                                    <select v-model="form.pendidikan_ahir" class="form-control">
                                        <option>S3</option>
                                        <option>S2</option>
                                        <option>S1</option>
                                        <option>D4</option>
                                        <option>D3</option>
                                        <option>D2</option>
                                        <option>D1</option>
                                        <option>SLTA</option>
                                        <option>SLTP</option>
                                        <option>SD</option>
                                    </select> <br>

                                    <div class="row">
                                        <div class="col-md-6">
                                                <span class="huruf_input">Nama Sekolah</span>
                                                <input v-model="form.sekolah" type="text" id="nilai" class="form-control" >
                                        </div>
                                        <div class="col-md-6">
                                                <span class="huruf_input">Thn Lulus</span>
                                                <input v-model="form.thn_lulus" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div><br>

                                    <span class="huruf_input">TMT CPNS</span>
                                    <input v-model="form.tmt_cpns" type="text" id="nilai" class="form-control" data-date-format="DD MMMM YYYY"><br>

                                    <div class="row">
                                        <div class="col-md-6">
                                                <span class="huruf_input">Golongan</span>
                                                <select v-model="form.gol" class="form-control">
                                                    <option selected="" disabled="">Golongan</option>
                                                    <option>IV/d</option>
                                                    <option>IV/c</option>
                                                    <option>IV/b</option>
                                                    <option>IV/a</option>
                                                    <option>III/d</option>
                                                    <option>III/c</option>
                                                    <option>III/b</option>
                                                    <option>III/a</option>
                                                    <option>II/c</option>
                                                    <option>II/b</option>
                                                    <option>II/a</option>
                                                    <option>I/c</option>
                                                </select> <br>
                                        </div>

                                        <div class="col-md-6">
                                                <span class="huruf_input">TMT Golongan</span>
                                                <input v-model="form.tmt_golongan" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div><br>

                                    <div class="row">
                                        <div class="col-md-6">
                                                <span class="huruf_input">Nama Jabatan</span>
                                                <select v-model="form.jabatan" class="form-control" id="esselon">
                                                    <option>-- Pilih Atasan Langsung Jabatan</option>
                                                    <option v-for="data in list_jabatan" :value="data._id" :key="data._id">[{{data.kode_jabatan}}] {{data.jabatan}}</option>
                                                </select><br>
                                        </div>
                                        <div class="col-md-6">
                                                <span class="huruf_input">TMT Jabatan</span>
                                                <input v-model="form.tmt_jabatan" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div><br>

                                    <div class="row">
                                        <div class="col-md-6">
                                                <span class="huruf_input">No Karpeg</span>
                                                <input v-model="form.no_karpeg" type="text" id="nilai" class="form-control" >
                                        </div>
                                        <div class="col-md-6">
                                                <span class="huruf_input">Kepemilikan Taspen</span>
                                                <select v-model="form.taspen" class="form-control" id="esselon">
                                                    <option>Ada</option>
                                                    <option>Tidak Ada</option>
                                                </select><br>
                                        </div>
                                    </div><br>

                                    <span class="huruf_input">Nomor NPWP</span>
                                    <input v-model="form.NPWP" type="text" id="nilai" class="form-control" ><br>

                                    <span class="huruf_input">Alamat Rumah</span>
                                    <input v-model="form.alamat" type="text" id="nilai" class="form-control" ><br>

                                    <div class="row">
                                        <div class="col-md-6">
                                                <span class="huruf_input">Kota </span>
                                                <input v-model="form.kota_asal" type="text" id="nilai" class="form-control" >
                                        </div>
                                        <div class="col-md-6">
                                                <span class="huruf_input">Kode Pos</span>
                                                <input v-model="form.kode_pos" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div><br>

                                    <span class="huruf_input">Nomor Kontak</span>
                                    <input v-model="form.kontak" type="text" id="nilai" class="form-control" ><br>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">LIHAT DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="h_isitable text-center">
                                                    <th class="text-center" colspan="3">
                                                        <img :src="file_path+form.file" width="30%">
                                                    </th>
                                                </tr>
                                                <tr class="bg-info">
                                                    <th style="width: 5%" class="text-center">No.</th>
                                                    <th style="width: 35%" class="text-center">Index</th>
                                                    <th style="width: 60%" class="text-center">Uraian</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- track-by="data.createdtime" -->
                                                

                                                <tr class="h_isitable">
                                                    <td class="text-center">1.</td>
                                                    <td>Unit Kerja</td>
                                                    <td>{{nm_unit_kerja}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">2.</td>
                                                    <td>Nama</td>
                                                    <td>{{check_gelar_depan(form.gelar_depan)}} {{form.nama}}{{ check_gelar_belakang(form.gelar_belakang)}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">3.</td>
                                                    <td>NIP</td>
                                                    <td>{{form.nip}}</td>
                                                </tr>

                                                <tr class="h_isitable">
                                                    <td class="text-center">4.</td>
                                                    <td>Jabatan</td>
                                                    <td>{{nm_jabatan}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">5.</td>
                                                    <td>Tempat, Tanggal Lahir</td>
                                                    <td>{{form.tempat_lahir}}, {{form.ttl}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">6.</td>
                                                    <td>Jenis Kelamin</td>
                                                    <td>{{form.jenis_kelamin}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">7.</td>
                                                    <td>Status Keluarga</td>
                                                    <td>{{form.status_keluarga}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">8.</td>
                                                    <td>Agama</td>
                                                    <td>{{form.agama}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">9.</td>
                                                    <td>Pendidikan Terahir</td>
                                                    <td>{{form.pendidikan_ahir}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">10.</td>
                                                    <td>Nama Sekolah</td>
                                                    <td>{{form.sekolah}}</td>
                                                </tr>

                                                <tr class="h_isitable">
                                                    <td class="text-center">11.</td>
                                                    <td>Tahun Lulus</td>
                                                    <td>{{form.thn_lulus}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">12.</td>
                                                    <td>TMT CPNS</td>
                                                    <td>{{form.tmt_cpns}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">13.</td>
                                                    <td>Golongan</td>
                                                    <td>{{form.gol}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">14.</td>
                                                    <td>TMT Golongan</td>
                                                    <td>{{form.tmt_golongan}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">15.</td>
                                                    <td>Nomor Karpeg</td>
                                                    <td>{{form.no_karpeg}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">16.</td>
                                                    <td>Kepemilikan Taspen</td>
                                                    <td>{{form.taspen}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">17.</td>
                                                    <td>Nomor NPWP</td>
                                                    <td>{{form.NPWP}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">18.</td>
                                                    <td>Alamat</td>
                                                    <td>{{form.alamat}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">19.</td>
                                                    <td>Kota / Kode POS</td>
                                                    <td>Kota : {{form.kota_asal}}, Kode POS :{{form.kode_pos}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">20.</td>
                                                    <td>Nomor Kontak</td>
                                                    <td>{{form.kontak}}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="submit" class="btn btn-success waves-effect">RUBAH</button> -->
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL CETAK xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_cetak_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-xlg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">CETAK DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">


                                        




                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="submit" class="btn btn-success waves-effect">RUBAH</button> -->
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL CETAK xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>
import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'


    const ADD_URL = URL_APP+'api/v1/simpeg_biodata/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';

    import Autocomplete from 'vue2-autocomplete-js'
    const URL_SERVER = URL_APP;
    const FILE_LOAD = URL_APP+'uploads/';
    const ADD_URL_JABATAN = URL_APP+'api/v1/simpeg_jabatan/';




    
    export default {
        name: "planning_kabupaten",
        components: { Autocomplete, OrganizationChart},
        
        data() {
            return {
                form : {
                    id : '',
                    nama : '',
                    nip : '',
                    gelar_depan : '',
                    gelar_belakang : '',
                    ttl : '',
                    tempat_lahir : '',
                    jenis_kelamin : '',
                    status_keluarga : '',
                    agama : '',
                    pendidikan_ahir : '',
                    sekolah : '',
                    thn_lulus : '',
                    tmt_cpns : '',
                    gol : '',
                    tmt_golongan : '',
                    jabatan : '',
                    tmt_jabatan : '',
                    no_karpeg : '',
                    taspen : '',
                    NPWP : '',
                    alamat : '',
                    kota_asal : '',
                    kode_pos : '',
                    kontak : '',
                    unit_kerja : '',
                    file : '',
                    
                },
                

                nm_jabatan : '',
                nm_unit_kerja : '',

                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',



                list_data: [],
                list_jabatan: [],
                list_jabatan_cetak: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER,

                cek_unit : false,
                cek_edit : false,
                cek_load_data : true,
                file_path : FILE_LOAD,
                file_old : '',



                ds: {},

                

            };
        },

        mounted() {
            localStorage.sidemenu = 'simpeg';
            
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;

            // this.form.unit_kerja = get_profile.profile.unit_kerja;




            this.getData();
        },

    // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){

                console.log(this.form.ttl)

                var formData = new FormData();

                formData.append('nama', this.form.nama);
                formData.append('nip', this.form.nip);
                formData.append('gelar_depan', this.form.gelar_depan);
                formData.append('gelar_belakang', this.form.gelar_belakang);
                formData.append('ttl', this.form.ttl);
                formData.append('tempat_lahir', this.form.tempat_lahir);
                formData.append('jenis_kelamin', this.form.jenis_kelamin);
                formData.append('status_keluarga', this.form.status_keluarga);
                formData.append('agama', this.form.agama);
                formData.append('pendidikan_ahir', this.form.pendidikan_ahir);
                formData.append('sekolah', this.form.sekolah);
                formData.append('thn_lulus', this.form.thn_lulus);
                formData.append('tmt_cpns', this.form.tmt_cpns);
                formData.append('gol', this.form.gol);
                formData.append('tmt_golongan', this.form.tmt_golongan);
                formData.append('jabatan', this.form.jabatan);
                formData.append('tmt_jabatan', this.form.tmt_jabatan);
                formData.append('no_karpeg', this.form.no_karpeg);
                formData.append('taspen', this.form.taspen);
                formData.append('NPWP', this.form.NPWP);
                formData.append('alamat', this.form.alamat);
                formData.append('kota_asal', this.form.kota_asal);
                formData.append('kode_pos', this.form.kode_pos);
                formData.append('kontak', this.form.kontak);
                formData.append('unit_kerja', this.form.unit_kerja);
                formData.append('file', this.form.file);

                fetch(ADD_URL+'createData', {
                    method: "POST",
                    headers: {
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body: formData
                }).then(res => res.json()).then((data_urusan) => {
                //   console.log(data_urusan);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'view', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.form.unit_kerja

                    })
                }).then((res) => res.json()).then((datanya) => {
                  this.list_data = datanya.data;
                  this.page_last = datanya.jml_data;
                  this.cek_load_data = false;
                })
            },
            
            editData: function(){

                var formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('nama', this.form.nama);
                formData.append('nip', this.form.nip);
                formData.append('gelar_depan', this.form.gelar_depan);
                formData.append('gelar_belakang', this.form.gelar_belakang);
                formData.append('ttl', this.form.ttl);
                formData.append('tempat_lahir', this.form.tempat_lahir);
                formData.append('jenis_kelamin', this.form.jenis_kelamin);
                formData.append('status_keluarga', this.form.status_keluarga);
                formData.append('agama', this.form.agama);
                formData.append('pendidikan_ahir', this.form.pendidikan_ahir);
                formData.append('sekolah', this.form.sekolah);
                formData.append('thn_lulus', this.form.thn_lulus);
                formData.append('tmt_cpns', this.form.tmt_cpns);
                formData.append('gol', this.form.gol);
                formData.append('tmt_golongan', this.form.tmt_golongan);
                formData.append('jabatan', this.form.jabatan);
                formData.append('tmt_jabatan', this.form.tmt_jabatan);
                formData.append('no_karpeg', this.form.no_karpeg);
                formData.append('taspen', this.form.taspen);
                formData.append('NPWP', this.form.NPWP);
                formData.append('alamat', this.form.alamat);
                formData.append('kota_asal', this.form.kota_asal);
                formData.append('kode_pos', this.form.kode_pos);
                formData.append('kontak', this.form.kontak);
                formData.append('unit_kerja', this.unit_kerja_edit);
                formData.append('file', this.form.file);
                formData.append('file_old', this.file_old);




                fetch(ADD_URL+'updateData', {
                    method: "POST",
                    headers: {
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body: formData
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                console.log(data);
                this.form = {
                    id : data.id,
                    nama : data.nama,
                    nip : data.nip,
                    gelar_depan : data.gelar_depan,
                    gelar_belakang : data.gelar_belakang,
                    ttl : data.ttl,
                    tempat_lahir : data.tempat_lahir,
                    jenis_kelamin : data.jenis_kelamin,
                    status_keluarga : data.status_keluarga,
                    agama : data.agama,
                    pendidikan_ahir : data.pendidikan_ahir,
                    sekolah : data.sekolah,
                    thn_lulus : data.thn_lulus,
                    tmt_cpns : data.tmt_cpns,
                    gol : data.gol,
                    tmt_golongan : data.tmt_golongan,
                    jabatan : data.jabatan,
                    tmt_jabatan : data.tmt_jabatan,
                    no_karpeg : data.no_karpeg,
                    taspen : data.taspen,
                    NPWP : data.NPWP,
                    alamat : data.alamat,
                    kota_asal : data.kota_asal,
                    kode_pos : data.kode_pos,
                    kontak : data.kontak,
                    unit_kerja : data.unit_kerja,
                    file : data.file,
                };

                this.unit_kerja_edit = data.unit_kerja;

                this.cek_edit = true;
                this.nm_unit_kerja = data.nm_unit_kerja;
                this.nm_jabatan = data.nm_jabatan
                this.file_old = data.file;
                this.getJabatan()
            },
            removeData : function(idnya, file){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL + "removeData", {
                        method: "POST",
                        headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                        },
                        body: JSON.stringify({
                        id: idnya,
                        file : file
                        })
                    }).then(res_data => {

                        this.alertku("success", "sukses menghapus data");
                        this.getData();
                        this.fileku = null;
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_jabatan = [];
                this.cek_edit = false;
            },

        // ================== TAMBAHAN ====================
            check_add : function(){
                this.getJabatan();
                if (this.form.unit_kerja == '') {
                    this.cek_unit = false;
                } else {
                    this.cek_unit = true;
                    this.getJabatan();
                }
            },
            getJabatan: function(){
                fetch(ADD_URL_JABATAN, {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.form.unit_kerja

                    })
                }).then((res) => res.json()).then((datanya) => {
                    this.list_jabatan = datanya;
                  console.log(datanya);
                })
            },
            getJabatanCetak: function(){
                fetch(ADD_URL+'cetakData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.unit_kerja

                    })
                }).then((res) => res.json()).then((datanya) => {
                    this.ds = datanya;


                })


            },
            onFileSelected : function(event){
                this.form.file = event.target.files[0];
                console.log(this.form.file);
            },
            check_gelar_depan : function(data){
                if (data == undefined || data == null || data == '') {
                    return ''
                } else {
                    return data+'. '
                }
            },
            check_gelar_belakang : function(data){
                if (data == undefined || data == null || data == '') {
                    return ''
                } else {
                    return ', '+data
                }
            },
        // ================== TAMBAHAN ====================



        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;
                this.cari_data();
                this.getData();
                // console.log(obj);
            },

            getAuto1 : function(obj){
                this.unit_kerja_edit= obj.id;
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================

        // ================== PAGINASI ====================
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            }

        // ================== PAGINASI ====================

        },
    // =============================================================== METHODS =========================================================================

    };
</script>
